import * as THREE from 'three';
import type { DataFormat } from '../../types';

export class OctreeNode {
  octreeId = '';

  key: string;

  url: string;

  requestHeader?: { [header: string]: string };

  numPoints: number;

  dataFormat: DataFormat;

  boundingBox: THREE.Box3 = new THREE.Box3();

  boundingSphere: THREE.Sphere = new THREE.Sphere();

  worldBoundingBox: THREE.Box3 = new THREE.Box3();

  worldBoundingSphere: THREE.Sphere = new THREE.Sphere();

  children: OctreeNode[] = [];

  constructor(
    key: string,
    url: string,
    numberPoints: number,
    boundingBox: THREE.Box3,
    dataFormat: DataFormat,
    requestHeader?: { [header: string]: string }
  ) {
    this.key = key;
    this.url = url;
    this.requestHeader = requestHeader;
    this.numPoints = numberPoints;
    this.boundingBox.copy(boundingBox);
    this.boundingBox.getBoundingSphere(this.boundingSphere);
    this.worldBoundingBox.copy(boundingBox);
    this.worldBoundingSphere.copy(this.boundingSphere);
    this.dataFormat = dataFormat;
  }

  applyWorldMatrix(matrix: THREE.Matrix4) {
    this.worldBoundingBox
      .copy(this.boundingBox)
      .applyMatrix4(matrix)
      .getBoundingSphere(this.worldBoundingSphere);
  }

  visitAll(visitor: (node: OctreeNode) => void) {
    visitor(this);
    this.children.forEach((child: OctreeNode) => {
      child.visitAll(visitor);
    });
  }
}
